import ErrorUtils from '~/utils/error_utils';

export default {
    getFormData(id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/dynamic-websites/form-json/' + id,
                method: 'GET',
                dataType: 'JSON',
                global: false
            })
                .done((json) => {
                    resolve(json);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    postCreateWebsite(formData) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/dynamic-websites/form/',
                data: formData,
                method: 'POST',
                global: false
            })
                .done((data) => {
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    postUpdateWebsite(formData) {
        const id = formData.id || '';

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/dynamic-websites/update/' + id,
                data: formData,
                method: 'POST',
                global: false
            })
                .done((data) => {
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    getSystemName(formData) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/dynamic-websites/slug/',
                method: 'POST',
                data: formData,
                global: false
            })
            .done((json) => {
                resolve(json);
            })
            .fail((xhr) => {
                reject(xhr);
            });
        });
    },

    searchWebsites(params = {}) {
        params.format_for_select = 1;
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/dynamic-websites/search/',
                type: 'GET',
                data: params
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                console.error('Users search failed.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    deleteWebsite(payload = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/dynamic-websites/delete/${payload.id || ''}`,
                type: 'POST',
                data: payload
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                console.error('Website delete failed.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    },

    generateLink(payload = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/dynamic-websites/generate-link`,
                type: 'POST',
                data: payload
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                console.error('Website link generation failed.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    },

    getSignatureLink(){
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/dynamic-websites/get-signature-link`,
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load link', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    },

    downloadWebsiteContent(websiteId){
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/dynamic-websites/download?id=${websiteId}`,
                method: 'GET',
                global: false,
                xhrFields: {
                    responseType: 'blob' // Ensure the response is treated as a binary file
                },
                processData: false, // Prevent jQuery from processing the data
                contentType: false // Ensure the content type is not overridden
            })
            .done((data) => {
                if (!(data instanceof Blob)) {
                    console.error('Response is not a Blob object');
                    reject(new Error('Invalid response type'));
                    return;
                }
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `website_${websiteId}.zip`; // Set the default file name
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl); // Clean up the object URL
                buildFlashMessage('Download will begin soon', 'success');
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to download website content', xhr);
                buildFlashMessage('Download Failed', 'error');
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    }

}
